import { AccessToken } from './access-token.model';

export class User {
    username: string;
    userEmail: string;
    isAdmin: boolean;
    accessToken: AccessToken;

    constructor(username: string, userEmail: string, isAdmin: boolean, accessToken: AccessToken) {
        this.username = username;
        this.userEmail = userEmail;
        this.isAdmin = isAdmin;
        this.accessToken = accessToken;
    }
}
